import React from 'react';
import { useNavigate } from 'react-router-dom';

export const LOGO_URL = "https://www.ilponticello.org/wp-content/uploads/2022/08/logohdblack.png";

export const Logo = ({ height = 44, className = '', linkHome = false }) => {
  const navigate = useNavigate();
  const img = (
    <img
      src={LOGO_URL}
      alt="Il Ponticello"
      style={{ height, width: 'auto' }}
      className={className}
      draggable={false}
    />
  );
  if (!linkHome) return img;
  return (
    <button
      onClick={() => navigate('/')}
      className="outline-none focus-visible:ring-2 focus-visible:ring-black rounded transition hover:opacity-80"
      aria-label="Home"
      type="button"
    >
      {img}
    </button>
  );
};

export default Logo;
